const minutesToHours = (minutes: number) => {
  let result = '';
  try {
    const hours = Math.floor(minutes / 60);
    const rest = Math.floor(minutes % 60);
    result = hours.toString().padStart(2, '0') + ':' + rest.toString().padStart(2, '0').substring(0, 2);
  } catch {
    result = '00:00';
  }

  return result;
};

export { minutesToHours };
